enum PageType {
  'Main' = 'Main',
  'Project' = 'Project',
  'Landing' = 'Landing',
  'News' = 'News',
}

export default PageType;
